// Actions

export const TOGGLE_FILTER_COLLAPSE = "TOGGLE_FILTER_COLLAPSE";
export const SET_ACTIVE_FILTER_CATEGORY = "SET_ACTIVE_FITLER_CATEGORY";
export const SET_SMALL_SCREEN = "SET_SMALL_SCREEN";

export function toggleFilterVisible() {
    return {
        type: TOGGLE_FILTER_COLLAPSE
    }
}

export function setActiveFilterCategory(categoryId) {
    return {
        type: SET_ACTIVE_FILTER_CATEGORY,
        categoryId,
    }
}

export function setSmallScreen(value) {
    return {
        type: SET_SMALL_SCREEN,
        value,
    }
}

// reducer 

let initialAppState = {
    filterCollapsed: false, 
    activeFilterCategory: null, 
    smallScreen: false
}

export function app(state = initialAppState, action) {
    switch(action.type) {
        case TOGGLE_FILTER_COLLAPSE:
            return {...state, filterCollapsed: !state.filterCollapsed};
        case SET_ACTIVE_FILTER_CATEGORY:
            return {...state, activeFilterCategory: action.categoryId};
        case SET_SMALL_SCREEN:
            return {...state, smallScreen: action.value};
        default:
            return state;
    }
}